var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('validation-provider',{ref:"provider",attrs:{"name":_vm.inputId,"vid":_vm.validationId}},[_c('input',{attrs:{"id":_vm.inputId,"type":"hidden"},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }